import React, {useEffect, useState} from "react";
import {useSubheader} from "../../../_metronic/layout";

//redux:
import {useDispatch, useSelector} from "react-redux";
import {fetchComponents, selectAllComponents, selectComponentsStatus} from "../../redux_slices/componentsSlice";
import {setHeaderImg, setIsHome, setLogo} from "../../redux/Layout/layoutSlice";

//compontents:
import {CircularProgress, Fade} from "@material-ui/core";
import ComputedComponent from "./Components/ComputedComponent";
import DynamicListComponent from "./Components/DynamicListComponent";
import VideoListComponent from "./Components/VideoListComponent";
import DefaultComponent from "./Components/DefaultComponent";
import VideosSearchResults from "../SearchResults";
import {checkPermission, loadParameter, loadUserParameter} from "../../redux_slices/contextSlice";
import {useTranslation} from "react-i18next";
import {connectStateResults} from "react-instantsearch-core";

const HomePage = () => {
    const subheader = useSubheader();
    const {t, i18n} = useTranslation();

    //redux:
    const dispatch = useDispatch();
    //store:
    const user = useSelector(state => state.context.credential);
    const components = useSelector(selectAllComponents);
    const componentsStatus = useSelector(selectComponentsStatus);

    const headerImg = useSelector(state => loadParameter(state, `homePic`));
    const logo = useSelector(state => loadParameter(state, `corporativeLogo`));

    const userLang = useSelector(state => loadUserParameter(state, `language`));
    const allowedLanguages = useSelector(state => loadParameter(state, "allowedLanguages"));
    const parsedAllowedLanguages =
        allowedLanguages && typeof allowedLanguages === "string" && JSON.parse(allowedLanguages);
    const currentLanguage = i18n?.languages?.[0];

    const canUploadVideos = useSelector(state => checkPermission(state, `settings.viewMenuLink`));
    const filteredComponents = components?.filter(component => component && component.data && component.data.length);
    const hasTopBannerWithVideos = components?.some(component => component.type_id === 4 && component.data?.length);

    //local state:
    const {isLoading, showResults} = useSelector(state => state.query);

    useEffect(() => {
        if (currentLanguage && userLang && currentLanguage !== userLang) {
            const userLanguageIsAllowed = parsedAllowedLanguages?.includes(userLang);

            userLanguageIsAllowed && i18n.changeLanguage(userLang);
        }
        dispatch(setHeaderImg(headerImg));
        dispatch(setLogo(logo));
        dispatch(setIsHome(true));
        dispatch(fetchComponents("homepage"));

        return () => {
            dispatch(setIsHome(false));
        };
    }, []);

    useEffect(() => {
        if (showResults) {
            subheader.setTitle(t("SEARCH_RESULTS_PAGE.TITLE"));
        } else subheader.setTitle("");
    }, [showResults]);

    const Carousels = connectStateResults(props => {
        const {searchState} = props;

        return (
            <Fade
                in={!searchState.query}
                mountOnEnter={true}
                unmountOnExit={true}
                timeout={{
                    exit: 0,
                    appear: 1000,
                    enter: 1000,
                }}
            >
                <div className={`homepage ${hasTopBannerWithVideos ? "" : "pt-24"}`}>
                    {filteredComponents.map(component =>
                        component.type_id === 4 ? (
                            <div key={component.id} id={`component_${component.id}`} className={'tour-topbanner'}>
                                {loadComponent(component)}
                            </div>
                        ) : null
                    )}
                    {filteredComponents.map(component =>
                        component.type_id !== 4 ? (
                            <div key={component.id} id={`component_${component.id}`} className={`tour-component`}>
                                {loadComponent(component)}
                            </div>
                        ) : null
                    )}
                </div>
            </Fade>
        );
    });

    const loadComponent = component => {
        if (component.type.name === "computed") {
            return <ComputedComponent component={component} />;
        } else if (component.type.name === "dynamicList") {
            return <DynamicListComponent component={component} />;
        } else if (component.type.name === "videoList") {
            return <VideoListComponent component={component} />;
        } else {
            return <DefaultComponent component={component} />;
        }
    };

    if (componentsStatus.type === "loading" || componentsStatus.type === "idle" || isLoading) {
        return (
            <div className="w-100 d-flex justify-content-center align-items-center h-100">
                <CircularProgress />
            </div>
        );
    } else if (componentsStatus.type === "succeeded") {
        if (components) {
            if (filteredComponents.length) {
                return (
                    <>
                        <VideosSearchResults />
                        <Carousels />
                    </>
                );
            } else {
                if (canUploadVideos) {
                    return (
                        <div
                            className="d-flex w-100 h-100 justify-content-center align-items-center text-muted text-center"
                            style={{minHeight: "25vh"}}
                        >
                            <p className="font-size-h4">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: t("HOME.CONTENT_FALLBACK.ADMIN", {
                                            user: user?.name || user?.username || "admin",
                                        }),
                                    }}
                                />
                                <a className="font-weight-bolder text-muted" href="/adminpanel">
                                    <u>{t("HOME.LINK.ADMINPANEL")}</u>
                                </a>
                            </p>
                        </div>
                    );
                } else {
                    return (
                        <div
                            className="d-flex w-100 h-100 justify-content-center align-items-center text-muted text-center"
                            style={{minHeight: "25vh"}}
                        >
                            <p className="font-size-h4">
                                {t("HOME.CONTENT_FALLBACK.USER", {user: user?.name || user?.username || "user"})}
                            </p>
                        </div>
                    );
                }
            }
        }
    } else if (componentsStatus.type === "failed") {
        return <div className="alert alert-error">{componentsStatus.message}</div>;
    }
    return (
        <div className="d-flex m-auto">
            <div className="alert alert-warning">{t("HOME.UNREGISTERED_ERROR")}</div>
        </div>
    );
};
export default HomePage;
